import axios from 'axios';
import { toast } from 'react-toastify';

// Set base URL
//axios.defaults.baseURL = 'https://82.25.105.61:5000/api';
//axios.defaults.baseURL = 'http://localhost:5000/api';
axios.defaults.baseURL = '/api';
// Add interceptor to include JWT token
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('Token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status } = error.response;
            if (status === 401) {
                toast.success("Session expired. Please log in again");
                localStorage.clear();
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
